import css from 'styled-jsx/css';

const styles = css.global`.newsletter{background:#eaeff4}.newsletter .email-state-capture{margin-top:-80px}`;

export default styles;